import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';

import NotFoundScreen from '../components/others/NotFoundScreen';

import ScrollToTop from '../components/common/ScrollToTop';

import About from '../pages/About';
import Contact from '../pages/Contact';
import HomeNine from '../themes/index9/HomeNine';
import Services from '../pages/Services';
import Impressum from '../pages/Impressum';
import Agb from '../pages/Agb';
import DataProtection from '../pages/DataProtection';

function index() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<HomeNine />} />

        <Route exact path='/about-us' element={<About />} />
        <Route exact path='/services' element={<Services />} />
        <Route exact path='/contact-us' element={<Contact />} />
        <Route exact path='/impressum' element={<Impressum />} />
        <Route exact path='/agb' element={<Agb />} />
        <Route exact path='/data-protection' element={<DataProtection />} />

        <Route element={<NotFoundScreen />} />
      </Routes>
    </HashRouter>
  );
}

export default index;

